import Link from "next/link";

export const ComponentAddressInfo = () => {
    return (
        <>
            SIA PATA<br/>
            Cēsu iela 14, Rīga, LV-1012<br/>
            <Link style={{color: "#5F6964"}} href="tel:+37167243135">+371 67243135</Link>
        </>
    )
}